export default __webpack_public_path__ + "static/media/premium-plus-illu-bg.54da893e.svg";